<template>
  <div class="contents_wrapper">
    <div class='contents'>
      <h2 class="large_label">マッチング詳細</h2>

      <TableBox :is-with-header="false" :table-contents="matchingData"/>

      <router-link :to="{name: 'WorkDetail', params: {workId: work.id}}" class="purple-ellipse_button">
        案件の詳細を見る
      </router-link>
      <router-link v-if='isClient' :to="{name: 'OperatorDetail', params: {operatorId: operatorId}}" class="purple-ellipse_button">
        オペレーターの詳細を見る
      </router-link>
      <router-link v-if='isOperator' :to="{name: 'ClientDetail', params: {clientId: clientId}}" class="purple-ellipse_button">
        クライアントの詳細を見る
      </router-link>

      <router-link v-if="hasStarted"  :to="{name: 'Meeting', params: {matchingId: matchingId}}" class="orange-ellipse_button">
        メッセージ画面へ
      </router-link>

      <div v-if="!hasAccepted && !hasRejected">
        <button @click="accept()" class="blue-ellipse_button">承諾</button>
        <button @click="reject()" class="pink-ellipse_button">拒否</button>
      </div>
      <div v-if="hasAccepted" class="blue-ellipse_button">承諾済</div>
      <div v-if="hasRejected" class="pink-ellipse_button">拒否済</div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import moment from "moment";
  import collection from "@/assets/js/functions/firebase/firestore/collection";
  import caller from '@/assets/js/functions/firebase/cloud_functions/caller.js';
  import TableBox from "@/components/molecules/box/TableBox";
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";

  export default {
    name: "MatchingDetail",

    components: {TableBox},

    mixins: [collection, caller],

    data() {
      return {
        matchingId: '',
        operatorId: '',
        clientId: '',

        matching: {},
        work: {},
      }
    },

    computed: {
      ...mapGetters({uid: 'auth/uid'}),

      isOperator() {
        return this.operatorId === this.uid
      },
      isClient() {
        return this.clientId === this.uid
      },

      hasAccepted() {
        if (this.isOperator) {
          return (this.matching.operatorStatus && this.matching.operatorStatus === 'accept');
        } else {
          return (this.matching.clientStatus && this.matching.clientStatus === 'accept');
        }
      },

      hasRejected() {
        if (this.isOperator) {
          return (this.matching.operatorStatus && this.matching.operatorStatus === 'reject');
        } else {
          return (this.matching.clientStatus && this.matching.clientStatus === 'reject');
        }
      },

      hasStarted() {
          return (this.matching.operatorStatus && this.matching.operatorStatus === 'accept') &&
              (this.matching.clientStatus && this.matching.clientStatus === 'accept');
      },

      matchingData() {
        return {
          title: {
            dt: '案件タイトル',
            dd: this.work.title,
          },
          estimationOfWorkTime: {
            dt: '見積時間',
            dd: this.work.estimationOfWorkTime ? `${this.work.estimationOfWorkTime}分` : '',
          },
          deadline: {
            dt: '期限',
            dd: !this.work.deadline ? '' : moment.unix(this.work.deadline.seconds).format('YYYY/MM/DD HH:mm'),
          },
        }
      },
    },

    beforeCreate() {
      Object.assign(this, {COLLECTION_NAMES});
    },

    async created() {
      this.matchingId = location.pathname.replace('/matching/pre/detail/', '');
      this.matchingId = this.matchingId.replace(/\/*$/, '');

      await this.getDoc(COLLECTION_NAMES.MATCHINGS, this.matchingId).then(async readMatching => {
        this.matching = readMatching;
        this.operatorId = readMatching.operator.id;
        this.clientId = readMatching.client.id;
        await this.getDoc(COLLECTION_NAMES.WORKS, readMatching.work.id).then(readWork => {
          // 循環参照を消す
          readWork['client'] = null;
          this.work = readWork;
        });
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });
    },

    methods: {
      async accept() {
        const params = {matchingId: this.matchingId, userId: this.uid};
        await this.callFunction(
          'acceptMatching',
          params
        ).then(() => {
          this.showSuccessMessage('マッチングを承諾しました。');
          this.showSuccessMessage('結果はメールにてお知らせいたします、少々お待ちください。');
          this.$router.push({name: 'MypageTop'});
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        })
      },

      async reject() {
        const params = {matchingId: this.matchingId, userId: this.uid};
        await this.callFunction(
          'rejectMatching',
          params
        ).then(() => {
          this.showSuccessMessage('マッチングを拒否しました。再マッチングするまでお待ちください。');
          this.$router.push({name: 'MypageTop'});
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        })
      },

    }
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    background: linear-gradient(45deg, $client_third, $client_third, $operator_secondary, $operator_secondary);

    > .contents {
      @include index-contents();

      > div {
        display: flex;
        justify-content: space-around;
        margin-top: 6rem;
        width: 100%;
      }

    }
  }
</style>